<template>
  <div class="wrapper">
    <div class="layout" @mousewheel.stop v-if="!isMobile">
      <bg :canvasWidth='width' :canvasHeight='height' class="xlz-bg"/>
    </div>
    <div class="mobileLayout" v-if="isMobile">
      <!-- <img class="bg" :src="`${$cdn}images/mobile/home_bg.png`" alt=""> -->
      <img class="bg" :src="`${$cdn}images/mobile/home_bg.png`" alt="">
      <img class="logo" :src="`${$cdn}images/k.png`" alt="">
      <img class="search-bar" :src="`${$cdn}images/mobile/home_search_bar.png`" alt="" @click="$router.push({path:'/search'})">
    </div>
  </div>
</template>
<script>
import bg from '@/components/background'
import browser from '@/utils/browser.js'

let height = window.innerHeight + 10
window.onresize = ()=>{
  height = window.innerHeight + 10
}
export default {
  components:{
    bg
  },
  data(){
    return {
      isMobile: browser.mobile
    }
  },
  computed:{
    width(){
      return height * (2120/1080)
    },
    height(){
      return height
    }
  },
  mounted(){
    
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
.mobileLayout {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  bottom: 10vh;
  .bg {
    width: 100%;
    height: 100%;
  }
  .logo {
    position: fixed;
    top: 5vw;
    left: 5vw;
    width: 40%;
    z-index: 100;
  }
  .search-bar {
    position: fixed;
    top: 5vw;
    right: 5vw;
    width: 30%;
    z-index: 100;
  }
}
.layout{
  position: relative;
  z-index: 9;
  width: 100%;
  height: 100%;
  .xlz-bg{
    position: absolute;
    top: 50%;
    z-index: 89;
    transform: translateY(-50%);
  }
}
</style>